import { NDialogProvider, NMessageProvider } from 'naive-ui'
import { RouterView } from 'vue-router'

export default defineComponent({
  name: 'App',
  setup() {
    const isMobile = ref(false)

    provide('isMobile', isMobile)

    const updateIsMobile = () => {
      // 使用 matchMedia API 检测屏幕尺寸
      const mediaQuery = window.matchMedia('(max-width: 768px)')
      isMobile.value = mediaQuery.matches
    }

    onMounted(() => {
      // 初始检测
      updateIsMobile()

      // 监听媒体查询变化
      const mediaQuery = window.matchMedia('(max-width: 768px)')
      mediaQuery.addEventListener('change', updateIsMobile)

      // 同时监听 resize 事件作为备用
      window.addEventListener('resize', updateIsMobile)

      // 监听设备方向变化
      window.addEventListener('orientationchange', updateIsMobile)
    })

    onUnmounted(() => {
      const mediaQuery = window.matchMedia('(max-width: 768px)')
      mediaQuery.removeEventListener('change', updateIsMobile)
      window.removeEventListener('resize', updateIsMobile)
      window.removeEventListener('orientationchange', updateIsMobile)
    })

    return () => (
      <NDialogProvider>
        <NMessageProvider>
          <RouterView />
        </NMessageProvider>
      </NDialogProvider>
    )
  }
})
